import { render, staticRenderFns } from "./ProductosFormComponent.vue?vue&type=template&id=c7ec22fa&"
import script from "./ProductosFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProductosFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductosFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports